<!-- MessageList.vue -->
<template>
    <div class="message-list">
        <div v-for="(message, index) in messages" :key="index" class="message-item">
<!--            <div v-if="isNotification">-->
                <div class="bgStyle" style="display: flex;justify-content:space-between;" @click="toPath(message.userAnnouncementsId)">
                    <div class="message-title">{{ showNotificationsTitle(message.title) }}</div>
                    <div class="message-date">
                        {{ message.createTime.split(" ")[0] }}
                    </div>
                </div>
                <div class="message-date" >{{extractAndTrimText(message.content,10)}}<span class="new-indicator"></span></div>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            messages: {
                type: Array,
                required: true
            },
            isNotification: {
                type: Boolean,
                required: true
            },

        },
        methods:{
            toPath(userAnnouncementsId){
                let defPath = '/Home/main/company-stat/notifications-stat?id='+userAnnouncementsId;
                if (this.$router.currentRoute.path !== defPath) {
                    this.$router.push(defPath).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            // 处理除 'NavigationDuplicated' 外的其他错误
                            throw err;
                        }
                        // 可以选择忽略或处理重复导航的错误
                    });
                }
            },

        }
    }
</script>

<style scoped>
    .message-list {
        max-height: 300px;
        overflow-y: auto;
    }
    .message-item {
        padding: 10px;
        border-bottom: 1px solid #e6e6e6;

    }
    .bgStyle:hover {
        background-color: #e7eaf1;
        cursor: pointer;
    }
    .message-title {
        font-size: 14px;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        color: #191A1B;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        margin-bottom: 5px;
    }
    .message-content {
        color: #666;
        margin-bottom: 5px;
        font-size: 12px;
    }
    .message-date {
        font-size: 12px;
        color: #999;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .new-indicator {
        width: 8px;
        height: 8px;
        background-color: red;
        border-radius: 50%;
        display: inline-block;
    }
</style>
